import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
export const preserveNewlines = (s?: string) => (s ? s.replace(/\r\n/g, "\n") : undefined);
